export default "__VITE_ASSET__70810791__"